var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    width: 16,
    height: 16,
    transform: "translate(1296 50.914) rotate(-90)",
    fill: "rgba(139,64,64,0.55)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32372",
    "data-name": "Group 32372",
    transform: "translate(-799 -180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5892",
    "data-name": "Mask Group 5892",
    transform: "translate(-497 154.086)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21627",
    "data-name": "Path 21627",
    d: "M0,0,2.652,2.653,0,5.3",
    transform: "translate(1306.652 41.855) rotate(90)",
    fill: "none",
    stroke: "#102d6f",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5962",
    "data-name": "Mask Group 5962",
    transform: "translate(2111 230.914) rotate(180)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32408",
    "data-name": "Path 32408",
    d: "M0,0,2.652,2.653,0,5.3",
    transform: "translate(1306.652 40.262) rotate(90)",
    fill: "none",
    stroke: "#102d6f",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.31105cf94e93e4d3c9b840d3aff7f419.svg";
export { ForwardRef as ReactComponent };